package com.essntl.features.itinerary.ui.send_message

import com.essntl.core.settings.domain.model.configuration.ConfigurationEmailModel
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.profile.domain.model.ProfileModel

data class SendMessageState(
    val getAllCategory: State<List<CategoryModel>> = State(),
    val getItinerary: State<ItineraryModel> = State(),
    val getItineraryServices: State<List<ItineraryServiceModel>> = State(),
    val getAllClients: State<List<ClientModel>> = State(),
    val getCurrentProfile: State<ProfileModel> = State(),
    val sendMessageList: State<Unit> = State(),
    val getAllMessages: State<List<MessageModel>> = State(),
    val sendMessageLoading: Set<String> = emptySet(),
    val checkContact: State<Unit> = State(),
    val getEmails: State<ConfigurationEmailModel?> = State(),
) {
    val isLoading: Boolean
        get() = getAllCategory.isLoading ||
            getItinerary.isLoading ||
            getItineraryServices.isLoading ||
            getAllClients.isLoading ||
            getCurrentProfile.isLoading

    val isFailure: Boolean
        get() = getAllCategory.isFailure ||
            getItinerary.isFailure ||
            getItineraryServices.isFailure ||
            getAllClients.isFailure ||
            getCurrentProfile.isFailure
}
